











import { Vue, Prop, Component } from "vue-property-decorator";
import VNumericInput, { VNumericInputApplication } from "./VNumericInput.vue";

@Component({ components: { VNumericInput } })
export default class VPercentInput extends Vue {
  @Prop({ default: 0, required: true }) readonly value!: number;
  @Prop({ default: 1 }) readonly scale?: number;

  private inserted = 0;

  mounted() {
    this.inserted = this.value * (this.scale || 1);
  }

  get inputValue() {
    return this.value * (this.scale || 1);
  }

  get usage() {
    return VNumericInputApplication.PERCENT;
  }

  onValueChanged(value: number) {
    this.inserted = value;
    this.notifyNewValue(value);
  }

  private notifyNewValue(value: number) {
    this.notifyEvent("input", value / (this.scale || 1));
  }

  private notifyEvent<T>(name: string, value: T | null = null) {
    if (value !== null) {
      this.$emit(name, value);
    } else {
      this.$emit(name);
    }
  }
}
